import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceDirectiveDiagnosticEntryComplexitiesProps<T> = {
  mapper?: (data: any) => T
}

export const useMaintenanceDirectiveDiagnosticEntryComplexities = <T,>({
  mapper = Mapper.default<T>(),
}: UseMaintenanceDirectiveDiagnosticEntryComplexitiesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceDirectiveDiagnosticEntryComplexities'],
    queryFn: () => privateAxios.get(`/maintenance/directive/diagnostic_entry_complexities`),
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
